import { useOverlayRuntime } from "@app/overlay/OverlayContext";

/**
 * Runtime-controls текущей window-surface (закрытие, z-index, placement).
 * @throws Error если вызван вне window-overlay
 */
export function useWindowControls() {
    const runtime = useOverlayRuntime();

    if (runtime.surface !== "window") {
        throw new Error("useWindowControls must be used inside a window overlay surface.");
    }

    return {
        id: runtime.id,
        zIndex: runtime.zIndex,
        blocking: runtime.blocking,
        isTopmost: runtime.isTopmost,
        placement: runtime.placement ?? "fullscreen",
        close: () => runtime.close(),
        focus: runtime.focus,
    };
}
